import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ConfirmPhoneGuard implements CanActivate {

  constructor(
    public router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      let user = JSON.parse(localStorage.getItem('User'));
      
      if (!user || !user.phone || !user.phone_verified) {
          this.router.navigate(['/verify-phone']);

          return false;
      }
    
    return true;
  }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/confirm-phone.guard.ts